var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDone = function SvgIconDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.269 15.356a.6.6 0 0 1-.24-.043.7.7 0 0 1-.22-.154L3.85 11.2a.66.66 0 0 1-.197-.481q0-.285.197-.481a.63.63 0 0 1 .46-.197.63.63 0 0 1 .459.197l3.5 3.5 7.94-7.941a.64.64 0 0 1 .47-.197q.274 0 .471.197a.64.64 0 0 1 .197.47q0 .274-.197.47L8.728 15.16a.7.7 0 0 1-.218.153.6.6 0 0 1-.241.044"
  })));
};
export default SvgIconDone;